/*
* Used for rendering gridded forms
* */

import React, { PropsWithChildren } from 'react';
import Container from '../grid/container';
import Row from '../grid/row';
import Col from '../grid/col';
import Typography from '../typography';
import RowSet from '../grid/row-set';

const FormRegion = ({ description, children }: PropsWithChildren<{ description: string }>): JSX.Element => (
    <div role="region" aria-roledescription={description}>
        <Container css={{
            padding: '24px 0',
        }}
        >
            <Row>
                <Col breakpoints={{ dt: { span: 12 } }}>
                    <Typography
                        fontWeight="medium"
                        fontSize={{ dt: 'xl' }}
                        css={{
                            textAlign: 'left',
                        }}
                    >
                        {description}
                    </Typography>
                </Col>
            </Row>
        </Container>
        <RowSet breakpoints={{
            dt: { between: 24 },
        }}
        >
            {children}
        </RowSet>
    </div>
);

export default FormRegion;
